import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { isMenuOpenVar } from 'core/api/apollo/cache';
import { List, ListItem } from 'core/ui/atoms';
import BodyScrollManager from 'core/ui/components/BodyScrollManager';

class MobileNav extends PureComponent {
  static propTypes = {
    opened: PropTypes.bool,
    navItems: PropTypes.arrayOf(PropTypes.object),
  };

  toggleMenu = () => {
    isMenuOpenVar(!isMenuOpenVar());
  };

  render() {
    const { opened, navItems } = this.props;

    return (
      <MobileNavOverlay opened={opened}>
        <BodyScrollManager disabled={opened} />
        <Heading />
        <Body>
          <Nav>
            <List unstyled>
              {(navItems || []).map((item, index) => (
                <ListItem key={`mobile-nav-${index}-${Math.random()}`} onClick={this.toggleMenu}>
                  {item}
                </ListItem>
              ))}
            </List>
          </Nav>
        </Body>
      </MobileNavOverlay>
    );
  }
}

const MobileNavOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: ${(p) => p.theme.colors.primary};
  opacity: 0;
  visibility: hidden;
  will-change: opacity;
  transition: all 0.3s;
  overflow-y: auto;
  ${(p) => p.opened && css`
    opacity: 1;
    visibility: visible;
  `};
`;

const Heading = styled.header`
  position: relative;
  width: 100%;
  height: ${(p) => p.theme.layout.headerHeight};
`;

const Body = styled.div`
  padding: 5vw 10vw;
`;

const Nav = styled.nav`
  a, button {
    font-family: ${(p) => p.theme.typography.familyLarken};
    display: block;
    text-decoration: none;
    padding: 1.25rem 0;
    margin-right: 0;
    font-size: 32px;
    color: rgba(255, 255, 255, 0.8);
    &.active {
      color: rgba(255, 255, 255, 0.8);
    }
  }
`;

export default MobileNav;
